import React from 'react';
import ComboBox from '../ComboBox';
import StateComboBox from '../../components/StateComboBox';
import CheckBox from '../../components/CheckBox';
import ProjectTypesCollection from '../../dao/collections/ProjectTypesCollection';
import MarketsCollection from '../../dao/collections/MarketsCollection';

import './ProjectFilters.scss';

import BaseComponent from '../../baseClasses/BaseComponent';

export class ProjectFilters extends BaseComponent {
  constructor(props){
    super(props);
    this.state = {
      selectedState: props.selectedFilters && props.selectedFilters.state ? props.selectedFilters.state : null,
      selectedProjectType: props.selectedFilters && props.selectedFilters.project_type ? props.selectedFilters.project_type : null,
      selectedStatuses: props.selectedFilters && props.selectedFilters.statuses ? props.selectedFilters.statuses : null,
      slectedMarkets: props.selectedFilters && props.selectedFilters.market ? props.selectedFilters.market : null,
    };

    this.statusList = [
      { type: 'all', name: this.textMap.allProjectStatuses, all: true },
      { type: 'not_started', name: this.textMap.notStarted },
      { type: 'in_progress', name: this.textMap.inProgress },
      { type: 'complete', name: this.textMap.completed },
    ];
  }

  componentDidMount() {
    this.projectTypesCollection = ProjectTypesCollection.build(null, null, localStorage.current_company_id);
    this.projectTypesCollection.fetchCurrent().then(projectTypes => {
      this.setState({ projectTypes });
    });

    let marketsList = [];
    this.marketsCollection = MarketsCollection.build(null, localStorage.current_company_id);
    this.marketsCollection.fetchCurrent().then(markets => {
      markets.forEach(market=>{
        marketsList.push({ type: market.id, name: market.name, market: market });
      });
      this.setState({ marketsList });
    });
  }

  componentDidUpdate(prevProps){
    if(prevProps.isDataCleared != this.props.isDataCleared){
      if(this.props.isDataCleared === true){
        this.setState({
          selectedProjectType: null,
          selectedState: null,
          selectedStatuses: null,
          slectedMarkets: null,
        });
      }
    }
  }

  handleCloseMenu(){
    if (this.state.menu){
      this.setState({ menu: null, displayMenu: '' });
    }
  }

  handleProjectTypeChange(type, option) {
    const { handleProjectTypeSelection } = this.props;
    if (handleProjectTypeSelection){
      if(type == 'all'){
        this.setState({
          selectedProjectType: 'all',
        });
        handleProjectTypeSelection(null);
      }
      else if(option){
        this.setState({
          selectedProjectType: option.project_type,
        });
        handleProjectTypeSelection(option.project_type);
      }
    }
  }

  handleMarketChange(multipleSelections) {
    const { handleMarketSelection } = this.props;
    const markets = multipleSelections.map(ms => { return ms.type; });
    this.setState({ selectedMarket: multipleSelections });
    handleMarketSelection(markets.length ? markets : null);
  }

  handleStateChange(type, option) {
    const { handleStateSelection } = this.props;
    if (handleStateSelection) {
      if(type == 'all'){
        handleStateSelection(null);
      }
      else{
        this.setState({
          selectedState: type,
        });
        handleStateSelection(type);
      }
    }
  }

  handleStatusChange(multipleSelections) {
    let { handleStatusSelection } = this.props;
    const statusTypes = multipleSelections.map(ms => { return ms.type; });
    this.setState({ selectedStatuses: multipleSelections });
    handleStatusSelection(statusTypes.length ? statusTypes : null);
  }

  handleShowArchived(checked) {
    const { handleArchiveSelection } = this.props;
    if (handleArchiveSelection) {
      handleArchiveSelection(checked);
    }
  }

  render(){
    const { selectedState, selectedProjectType, selectedStatuses, selectedMarket } = this.state;

    let currentState = selectedState ? { type: selectedState, name: selectedState } : { type: 'all', name: '-- All States --' };

    let stateSelector = <StateComboBox defaultText={this.textMap.state} includeAll={true} currentOption={currentState} handleStateChange={this.handleStateChange}
      displayFontStyle={{ fontSize: '14px', fontFamily: 'Open Sans', color: '#8B8B8B' }} width={217} height={32} maxHeight={300}
      menuHeight={270} />;

    let marketOption = [];
    if (this.state.marketsList){
      marketOption = this.state.marketsList.map(market => {
        let selected = false;
        if (selectedMarket) {
          let foundMarket = selectedMarket.find(mkt => {
            return mkt.type ? mkt.type == market.type : mkt == market.type;
          });
          selected = foundMarket != undefined;
        }

        market.selected = selected;
        return market;
      });
    }

    let marketSelector = (
      <ComboBox 
        id={'marketPicker'} 
        options={marketOption} 
        multiSelect={true}
        hasBorder={false} 
        underlined={false} 
        width={217}
        height={32} 
        displayFontStyle={{ fontSize: '14px' }} 
        handleMultiMenuSelection={this.handleMarketChange}
        placeHolderText={'Market'} 
      />
    );
    
    let project_typesList = [];
    let currentProjectType = { type: 'all', name: '-- ' + this.textMap.allProjectTypes + ' --' };
    if (this.state.projectTypes) {
      project_typesList = this.state.projectTypes.map(project_type => {
        let project_typeOption = { type: project_type.id, name: project_type.name, project_type: project_type };
        if (selectedProjectType && project_type.id == selectedProjectType.id) {
          currentProjectType = project_typeOption;
        }
        return project_typeOption;
      });
    }
    project_typesList.splice(0,0, { type: 'all', name: '--' + this.textMap.allProjectTypes + '--' });

    let project_typeSelector = (
      <ComboBox 
        id={'project_typePicker'} 
        options={project_typesList} 
        currentOption={currentProjectType}
        hasBorder={false} 
        underlined={false} 
        width={217}
        height={32} 
        displayFontStyle={{ fontSize: '14px' }} 
        handleSelection={this.handleProjectTypeChange}
        placeHolderText={this.textMap.projectType} 
      />
    );

    let statuses = this.statusList.map(status => {
      let selected = false;
      if (selectedStatuses) {
        let foundType = selectedStatuses.find(sta => {
          return sta.type ? sta.type == status.type : sta == status.type;
        });
        selected = foundType != undefined;
      }

      status.selected = selected;
      return status;
    });

    let statusSelector = (
      <ComboBox 
        id={'statusPicker'} 
        options={statuses}
        multiSelect={true}
        hasBorder={false} 
        underlined={false}
        width={217}
        height={32}
        displayFontStyle={{ fontSize: '14px' }}
        handleMultiMenuSelection={this.handleStatusChange}
        placeHolderText={this.textMap.allProjectStatuses}
      />
    );

    return(
      <div className="filters">
        <div>
          <div className='filter-selector-label'>
            {this.textMap.projectType.toUpperCase()}
          </div>
          <div className='filter-selector-container'>
            {project_typeSelector}
          </div>
        </div>
        <div>
          <div className='filter-selector-label'>
            {this.textMap.state.toUpperCase()}
          </div>
          <div className='filter-selector-container'>
            {stateSelector}
          </div>
        </div>
        {this.props.isMarketFilterEnabled && <div>
          <div className='filter-selector-label'>
            {'MARKET'}
          </div>
          <div className='filter-selector-container'>
            {marketSelector}
          </div>
        </div>}
        <div>
          <div className='filter-selector-label'>
            {'PROJECT STATUS'}
          </div>
          <div className='filter-selector-container'>
            {statusSelector}
          </div>
        </div>
        
        <div className="show-archived-checkbox">
          <div className="checkbox">
            <CheckBox key="archived-checkbox" toggleCheckBox={this.handleShowArchived}
              checked={this.props.showArchived} />
          </div>
          <div className="caption">Show Archived Projects Only</div>
        </div>
      </div>
    );
  }
}

export default ProjectFilters;



// WEBPACK FOOTER //
// ./src/components/ProjectFilters/index.js